/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DetailsInfo_deliverableStateTypes$ref: FragmentReference;
declare export opaque type DetailsInfo_deliverableStateTypes$fragmentType: DetailsInfo_deliverableStateTypes$ref;
export type DetailsInfo_deliverableStateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: DetailsInfo_deliverableStateTypes$ref,
|};
export type DetailsInfo_deliverableStateTypes$data = DetailsInfo_deliverableStateTypes;
export type DetailsInfo_deliverableStateTypes$key = {
  +$data?: DetailsInfo_deliverableStateTypes$data,
  +$fragmentRefs: DetailsInfo_deliverableStateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DetailsInfo_deliverableStateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '59c1078004dcd1ada49e26688424ef3e';
module.exports = node;
